<ion-header><app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content>
	<ion-item lines="none" class="header blue-item">
    <ion-label>
      <h1 class="h1-blue-page">{{ 'ACCOUNT.PROFILE_CREATOR.HEADER' | translate }}</h1>
    </ion-label>
	</ion-item>
	<div class="wrapper">
    <ion-item lines="none" class="info blue-item">
      <ion-label class="ion-text-center">{{ 'ACCOUNT.PROFILE_CREATOR.LIMIT' | translate }}</ion-label>
    </ion-item>
    <ion-list class="ion-no-padding">
      <form #form="ngForm">
      <div class="profile-wrapper" *ngFor="let profile of profiles; let index = index; let c = count;">
        <ion-item lines="none" class="ion-no-padding child blue-item">
          <ion-label class="ion-text-center">
            {{ 'ACCOUNT.PROFILE_CREATOR.CHILD' | translate }} {{ index + 1 }}
          </ion-label>
        </ion-item>
          <ion-item lines="none" class="ion-no-padding firstinput blue-item">
            <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.PRENOM' | translate}}</ion-label>
            <ion-input required [(ngModel)]="model.firstName[index]" name="firstName{{index}}" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" type="text" #firstName = "ngModel"></ion-input>
          </ion-item>
          <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
          <div class="errortextpassword" [hidden]= "firstName.valid || firstName.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>

          <ion-item lines="none" class="ion-no-padding firstinput blue-item">
            <ion-label  position="stacked">{{'ACCOUNT.PROFILE_CREATOR.NOM' | translate}}</ion-label>
            <ion-input required [(ngModel)]="model.lastName[index]" name="lastName{{index}}"  [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" type="text" #lastName = "ngModel"></ion-input>
          </ion-item>
        <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
          <div class="errortextpassword" [hidden]= "lastName.valid || lastName.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
          <ion-item lines="none" class="ion-no-padding abonumber blue-item" [hidden] = "themeClass === 'mwjp'">
            <ion-label  position="stacked">{{'ACCOUNT.PROFILE_CREATOR.SUBSCRIPTION_NUMBER' | translate}}</ion-label>
            <ion-input [required] = "!model.coupon[index]" [(ngModel)]="model.subscriber_number[index]" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" type = "text" name="subscriber_number{{index}}" #subscriber_number = "ngModel"></ion-input>
          </ion-item>
          <div class="qmarkwrapper" [hidden] = "themeClass === 'mwjp'">
            <img (click)="presentPopover2($event)" class="qmark2" src="../../../assets/img/qmark.png" />
          </div>
        <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
        <div class="errortextpassword" [hidden]= "subscriber_number.valid || subscriber_number.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
        <ion-item lines="none" class="ion-no-padding abonumber blue-item">
            <ion-label  position="stacked">{{'ACCOUNT.PROFILE_CREATOR.COUPON' | translate}}</ion-label>
            <ion-input [required] = "!model.subscriber_number[index]" (ionChange) = "changeHandler()" [(ngModel)]="model.coupon[index]" [ngClass] = "{'invalid': error_coupon, 'dirty': error_coupon}" type = "text" name="coupon{{index}}" #coupon = "ngModel"></ion-input>
        </ion-item>
        <div class="qmarkwrapper">
            <img (click)="presentPopover3($event)" class="qmark3" src="../../../assets/img/qmark.png" />
          </div>
        <div class="errortext" [ngClass]= "{'visible': error_coupon, 'hidden':  coupon.valid}">
          <span>{{ 'ERROR.COUPON.INVALID_CODE' | translate }}</span>
        </div>
        <div class="errortextpassword" [hidden]= "coupon.valid || coupon.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
      </div>
      <ion-item lines="none" class="ion-no-padding addchild blue-item" (click) = "cloneTemplate()">
        <ion-label class="ion-text-center">
          <img src="../../../assets/img/add-child-icon.png">
          {{ 'ACCOUNT.PROFILE_CREATOR.ADD_CHILD' | translate }}
        </ion-label>
      </ion-item>
      <ion-button [disabled] = "!form.valid" (click)="createProfile()">
        {{ 'ACCOUNT_CREATION.VALIDER' | translate }}
      </ion-button>
      </form>
    </ion-list>
	</div>
  <!-- <div class="aide-dev" (click)="showTempPopUp()">Cliquer ici pour les codes d'accès gratuits</div> -->
</ion-content>
<ion-footer>
	<app-bottom-menu></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
